import { ActionContext } from 'vuex';
import { copy } from '../helpers';
import { post } from '../helpers/api';
import { post as postOidc } from '../helpers/api';
import { prepareQuery } from '../helpers/graphql';
import { formatTimeFromSeconds } from '../utils';
import { Apps, AppVersions, AppVersionSummary, UpdateKeys } from '../../graphql/app.gql';
import { UpdateAppSection, UpdateAppSectionsTranslations, AddScreen, DeleteSection, DeleteScreen } from '../../graphql/settings.gql';
import { AppKeyInput, AppSectionInput, AppSectionTranslationInput } from '@/graphql-schema';

const headersJson = { 'Content-Type': 'application/json' };

async function executeGraphQL(ctx: ActionContext<any,any>, data: { query: any, variables?: any }) {
    const endpoint = `/_graph`;

    type ResultType = { data: any, errors: any[] }

    try {
        let result = await post(endpoint, data, headersJson).then(res => res.data) as ResultType;

        if (result.errors && result.errors.length > 0) {
            console.error(result.errors);
            return false;
        }
        return result.data;
    }
    catch (ex) {
        console.error(ex);
        return false;
    }
}

function invalidateCache(ctx: ActionContext<any,any>, key: string) {
}

function checkCache(ctx: ActionContext<any,any>, key: string) : boolean | undefined {
    if (ctx.state.cacheControl[key] == 'reload') {
        ctx.state.cacheControl[key] == null;
        return true;
    }
}

async function getApps(ctx: ActionContext<any,any>, data: {})
{
    let req = prepareQuery(Apps, data);
    let res = await executeGraphQL(ctx, req);
    if (res) {
        ctx.commit('setApps', res);
        return res.apps;
    }
    return null;
}

async function getAppVersions(ctx: ActionContext<any,any>, data: {appId: number})
{
    data['isSummary'] = false;
    let req = prepareQuery(AppVersions, data);
    let res = await executeGraphQL(ctx, req);
    if (res) {
        ctx.commit('setAppVersions', res);
        return res.appVersions;
    }
    return null;
}

async function getAppVersionSummary(ctx: ActionContext<any,any>, data: {versionId: number})
{
    data['isSummary'] = true;
    let req = prepareQuery(AppVersionSummary, data);
    let res = await executeGraphQL(ctx, req);
    if (res && Array.isArray(res.appVersions) && res.appVersions.length == 1) {
        let summary = res.appVersions[0];
        ctx.commit('setAppVersionSummary', { appVersionSummary: summary });
        return summary;
    }
    return null;
}

async function updateKeys(ctx: ActionContext<any,any>, data: {keys: AppKeyInput[]})
{
    let req = prepareQuery(UpdateKeys, data);
    let res = await executeGraphQL(ctx, req);
    if (res && res.updateKeys) {
        return true;
    }
    return null;
}

async function updateAppSection(ctx: ActionContext<any,any>, data: {section: AppSectionInput})
{
    let req = prepareQuery(UpdateAppSection, data);
    let res = await executeGraphQL(ctx, req);
    if (res && res.updateSection) {
        return true;
    }
    return null;
}

async function updateAppSectionsTranslations(ctx: ActionContext<any,any>, data: {sectionsTranslations: AppSectionTranslationInput})
{
    let req = prepareQuery(UpdateAppSectionsTranslations, data);
    let res = await executeGraphQL(ctx, req);
    if (res && res.updateSectionsTranslations) {
        return true;
    }
    return null;
}

async function addScreenInSection(ctx: ActionContext<any,any>, data: {sectionId: number})
{
    let req = prepareQuery(AddScreen, data);
    let res = await executeGraphQL(ctx, req);
    if (res && res.addScreen) {
        return true;
    }
    return null;
}

async function deleteSection(ctx: ActionContext<any,any>, data: {sectionId: number})
{
    let req = prepareQuery(DeleteSection, data);
    let res = await executeGraphQL(ctx, req);
    if (res && res.deleteSection) {
        return true;
    }
    return null;
}

async function deleteScreen(ctx: ActionContext<any,any>, data: {screenId: number})
{
    let req = prepareQuery(DeleteScreen, data);
    let res = await executeGraphQL(ctx, req);
    if (res && res.deleteScreen) {
        return true;
    }
    return null;
}

export const actions = {
    getApps,
    getAppVersions,
    getAppVersionSummary,
    updateKeys,
    updateAppSection,
    updateAppSectionsTranslations,
    addScreenInSection,
    deleteSection,
    deleteScreen
}
